import DesktopIntro from '../../@common/Intro/Desktop';
import DesktopPageWrapper from '../../@common/PageWrapper/Desktop';
import RootLayout from '../../@common/RootLayout';
import DesktopPageNavigation from '../../@common/PageNavigationDrawer/Desktop';
import {
  MessageBoxItemType,
  PdfViewerRedirect,
} from '../../PdfViewer/index.types';
import DesktopPage from '../../@common/Viewer/Desktop';
import DesktopAnnotationLayer from '../../@common/Layer/OneOnOneAnnotationLayer/Desktop';
import DesktopPageNavigationButton from '../../@common/PageNavigationButton/Desktop';

interface Props {
  translateKoToEn: (item: string) => string;
  file: Omit<PdfViewerRedirect, 'isDownloadEnabled'>;
  messageBoxItems?: MessageBoxItemType[];
}

const DesktopPdfPreview = ({
  translateKoToEn,
  file,
  messageBoxItems,
}: Props) => {
  const { name, thumnail, pages } = file;

  return (
    <RootLayout mode="desktop">
      <DesktopPageNavigation
        translateKoToEn={translateKoToEn}
        fileName={name}
        pages={thumnail}
      />

      <DesktopIntro translateKoToEn={translateKoToEn} />

      <DesktopPageWrapper totalPage={pages}>
        <DesktopPage
          thumnails={thumnail?.map((value) => {
            if (value?.thumnail) {
              return {
                src: value.thumnail,
                imageSources: value.imageSources,
              };
            }
            return null;
          })}
        />
      </DesktopPageWrapper>

      <DesktopPageNavigationButton
        totalPage={Number(pages)}
        isMoveCtaFormPageRequirements={true}
      />

      {thumnail && (
        <DesktopAnnotationLayer
          thumnail={thumnail}
          messageBoxItems={messageBoxItems}
          isPreview
        />
      )}
    </RootLayout>
  );
};

export default DesktopPdfPreview;
